import React from 'react';
import { Box, Modal } from '@mui/material';
import { ThemeContext } from 'src/store/ContextStore';
import TextModal from './TextModal';

const Comment = ({
  node,
  memberRecords,
  setMemberRecords,
  handleClose,
  setPedigreeState
}) => {
  const { theme } = React.useContext(ThemeContext);

  const guardRef = React.useRef(null);
  const style = {
    bgcolor: theme.appearance.color,
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    borderRadius: 2,
    p: 2
  };

  return (
    <>
      {/* A click outside or Escape asks first while the text holds an unsaved
          change (TGCLOUD-1902): the modal's own guarded close. */}
      <Modal
        open={node}
        onClose={() => (guardRef.current ? guardRef.current() : handleClose())}
      >
        <Box sx={style}>
          <TextModal
            menu={true}
            node={node}
            setMemberRecords={setMemberRecords}
            memberRecords={memberRecords}
            handleClose={handleClose}
            guardRef={guardRef}
            setPedigreeState={setPedigreeState}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Comment;
